import * as Hammer from 'hammerjs/hammer'
import { breakpoints } from '@utilities/sal-breakpoint/sal-breakpoint'
import {animation, availableAnimations} from "@global/global-animation";

const CONSTANTS = {
    SLIDER_CLASS: "global-tile__row--slider",
    SLIDE_CLASS: "global-tile--slider",
    TOUCH_AREA_CLASS: 'global-tile__row--slider',
    THRESHOLD: 200,
    ACTIVE_SLIDE_CLASS: 'slide--active',
    ACTIVATED_CLASS: 'slider--initialized'
};

let options = {
    sliderClass: CONSTANTS.SLIDER_CLASS,
    slideClass: CONSTANTS.SLIDE_CLASS,
    activeClass: CONSTANTS.ACTIVE_SLIDE_CLASS,
    sliderActivatedClass: CONSTANTS.ACTIVATED_CLASS,
    touchArea: CONSTANTS.TOUCH_AREA_CLASS,
    threshold: CONSTANTS.THRESHOLD
};

const actions = {
    nextElement: (slider) => {
        let activeElement = slider.querySelector(`.${options.activeClass}`);

        if (activeElement.nextElementSibling) {
            const newActive = activeElement.nextElementSibling;

            animation.addAnimation(activeElement, availableAnimations.fades.fadeOutLeft, null, [{
                eventType: 'animationend',
                eventCallback: e => {
                    e.target.display = '';
                    e.target.classList.remove(options.activeClass);
                    newActive.style.display = 'flex';
                    animation.addAnimation(newActive, availableAnimations.fades.fadeInRight, null, [{
                        eventType: 'animationend',
                        eventCallback: e => {
                            e.target.classList.add(options.activeClass);
                            e.target.style = '';
                            actions.updateIndicator('next');
                        }
                    }])
                }
            }]);
        }
    },
    prevElement: (slider) => {
        let activeElement = slider.querySelector(`.${options.activeClass}`);
        if (activeElement.previousElementSibling) {
            const newActive = activeElement.previousElementSibling;

            animation.addAnimation(activeElement, availableAnimations.fades.fadeOutRight, null, [{
                eventType: 'animationend',
                eventCallback: e => {
                    e.target.display = '';
                    e.target.classList.remove(options.activeClass);
                    newActive.style.display = 'flex';
                    animation.addAnimation(newActive, availableAnimations.fades.fadeInLeft, null, [{
                        eventType: 'animationend',
                        eventCallback: e => {
                            e.target.classList.add(options.activeClass);
                            e.target.style = '';
                            actions.updateIndicator('prev');
                        }
                    }])
                }
            }]);
        }
    },
    updateIndicator: (direction) => {
        const activeIndicator = document.querySelector('.news .indicator--active');
        if (activeIndicator) {
            if (direction === "next") {
                if (activeIndicator.nextElementSibling) {
                    activeIndicator.classList.remove('indicator--active');
                    activeIndicator.nextElementSibling.classList.add('indicator--active');
                }
            }

            if (direction === "prev") {
                if (activeIndicator.previousElementSibling) {
                    activeIndicator.classList.remove('indicator--active');
                    activeIndicator.previousElementSibling.classList.add('indicator--active');
                }
            }
        }
    },
    createIndicator: (numberOfIndicators) => {
        let i = 0;
        let indicatorWrapper = document.createElement('div');
        indicatorWrapper.classList.add('slider__indicator');
        let indicator = document.createElement('span');
        indicator.classList.add('indicator');

        while (i < numberOfIndicators) {
            indicatorWrapper.appendChild(indicator.cloneNode(true));
            i++;
        }

        indicatorWrapper.firstChild.classList.add('indicator--active');

        return indicatorWrapper;
    }
};

const eventHandler = {
    panDetected: e => {
        if (window.innerWidth < breakpoints.md) {
            if (e.isFinal) {
                if (e.additionalEvent === 'panleft') {
                    actions.nextElement(e.target.closest(`.${options.sliderClass}`));
                }
                if (e.additionalEvent === 'panright') {
                    actions.prevElement(e.target.closest(`.${options.sliderClass}`));
                }
            }
        }
    }
};

const tileSlider = {
    init: (overwriteOptions) => {
        options = Object.assign(options, overwriteOptions);

        let touchAreaElements = document.querySelectorAll(`.${options.touchArea}`);

        let hammerInstances = [];
        touchAreaElements.forEach((touchArea) => {
            if (touchArea.classList.contains('paginated')) {
                return
            }
            const numberIndicators = touchArea.childNodes.length;

            if (touchArea.nextSibling) {
                touchArea.parentNode.insertBefore(actions.createIndicator(numberIndicators), touchArea.nextSibling);
            } else {
                touchArea.parentNode.append(actions.createIndicator(numberIndicators));
            }

            touchArea.firstChild.classList.add(options.activeClass);
            touchArea.classList.add(options.sliderActivatedClass);
            const hammerInstance = new Hammer(touchArea);
            hammerInstance.get('pan').set({ direction: Hammer.DIRECTION_HORIZONTAL, threshold: options.threshold });
            hammerInstance.on('pan', eventHandler.panDetected);
            hammerInstances.push(hammerInstance);
        });
    }
};

export { tileSlider };
